import axiosInstance from '../common/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

export const getUserInfo = async (userId) => {
  const res = await axiosInstance.get(`${backendUrl}/api/users/${userId}`);
  return res.data;
};

export const updateUserInfo = async (data) => {
  const res = await axiosInstance.post("/api/users", data);
  return res.data;
};


export const updateUserDefaultShipping = async (userId, data) => {
  const res = await axiosInstance.put(`${backendUrl}/api/users/${userId}/default-shipping-address`, data);
  return res.data;
};